import { Injectable } from '@angular/core';
import { ApiUrlService } from '../shared-services/api-url.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DistServicesService {

  constructor(private base_url:ApiUrlService, private http:HttpClient) { 
    
    console.log( 'BASE_URL',this.base_url.BASE_DIST);
  }
  
  createNewDist(req: any): Observable<any> {
    const url = `${this.base_url.BASE_DIST}/create`;
    return this.http.post(url, req);
  }
  getDistWithPagination(paginationData:any): Observable<any> {
    const url = `${this.base_url.BASE_DIST}/get_with_paginate?limit=${paginationData.pageLimit}&currentPage=${paginationData.pageNumber}`;
    return this.http.get(url);
  }
  getADist(id:any): Observable<any> {
    const url = `${this.base_url.BASE_DIST}/${id}`;
    return this.http.get(url);
  }
  UpdateADist(req: any): Observable<any> {
    const url = `${this.base_url.BASE_DIST}/update/${req?.id}`;
    return this.http.put(url,req);
  }
  deleteDist(DistReq: string): Observable<any> {
    const url = `${this.base_url.BASE_DIST}/delete`;
    return this.http.post(url,DistReq);
  }
}
